import { Component, OnInit } from '@angular/core';
import { NgbModal, NgbModalRef } from '@ng-bootstrap/ng-bootstrap';
import { MQService, MQMessage } from '../../services/mq.service';
import { MQComponent } from '../MQComponent'

@Component({
    selector: 'app-dialog-container',
    templateUrl: './dialogcontainer.component.html',
    styleUrls: ['./dialogcontainer.component.scss'],
    providers: [NgbModal]
})

export class DialogContainerComponent extends MQComponent implements OnInit {
    private modals: NgbModalRef[] = [];
    private options: object;
    constructor(
        protected mq: MQService,
        private modalService: NgbModal
    ) {
        super(mq);
        this.options = { backdrop : 'static', keyboard: false};
    }

    close() {
        const modal = this.modals.pop();
        if (modal) {
          modal.close();
        }
        this.mq.notify('address-modal-closed', {});
    }

    ngOnInit() {
        super.listenOn('open-dialog', (msg: MQMessage) => {
            const { content, params } = msg;
            if (params !== undefined) {
                Object.assign(this.options, params);
            }
            this.modals.push(this.modalService.open(content, this.options));
        });
        super.listenOn('close-dialog', (msg: MQMessage) => {
            const modal = this.modals.pop();
            if (modal) {
              modal.close();
            }
        });
    }
}
